module.exports = __webpack_public_path__ + "img/8.17dc00f2.png";